import { getTodayAsLocalISOString } from "./date-iso-string"

function validateAge(
  birthDate: string | undefined,
  age: number,
  operator: "<=" | ">="
) {
  if (!birthDate) {
    return false
  }

  const [year, month, day] = birthDate.split("-")
  if (!(year && month && day)) {
    return false
  }

  // Birthdate validation should be checked against user's local
  // day/time so cutoff is not shifted for comparisons
  const cutoffDate = getTodayAsLocalISOString({ yearOffset: -age })

  return operator === "<=" ? birthDate <= cutoffDate : birthDate >= cutoffDate
}

export function minAge(age: number, message?: string) {
  return {
    name: "minAge",
    message: message || {
      key: "yup.common.date.youngerThanMinAge",
      values: { age },
    },
    test: (birthDate: string | undefined) => validateAge(birthDate, age, "<="),
  }
}

export function maxAge(age: number, message?: string) {
  const today = new Date()
  const minDate = today.getFullYear() - age

  return {
    name: "maxAge",
    message: message || {
      key: "yup.common.date.exceedsMinDate",
      values: { minDate },
    },
    test: (birthDate: string | undefined) => validateAge(birthDate, age, ">="),
  }
}
